<template>
  <div
    class="tab-view c:col-center"
    :style="{
      '--tabbar-height': computedTabHeight,
      '--tabbar-padding-x': computedTabPaddingX,
      '--tabbar-text-color': tabbarTextColor,
      '--tabbar-rail-color': tabbarRailColor,
      '--tabs-count': tabs.length || 1,
      '--active-index': activeIndex,
    }"
  >
    <div class="tabbar c:row-center">
      <div
        v-for="(tab, index) in tabs"
        :key="tab.key"
        class="tab-item c:row-center"
        :class="{ active: tab.key === activeKey }"
        @click="throttledOnTabClick(tab, index)"
      >
        {{ tab.label }}
      </div>
      <div class="active-bar-rail">
        <div class="active-bar"><div class="active-bar-highlight"></div></div>
      </div>
    </div>
    <div class="active-view">
      <keep-alive>
        <slot v-if="hasSlot" :name="activeKey" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { throttle } from "@/utils";

export default {
  props: {
    tabs: Array,
    tabHeight: {
      type: [Number, String],
      default: 50,
    },
    tabPaddingX: {
      type: [Number, String],
      default: 22,
    },
    tabbarTextColor: {
      type: String,
      default: "#ccc",
    },
    tabbarRailColor: {
      type: String,
      default: "transparent",
    },
  },
  data() {
    return {
      activeKey: "",
      activeIndex: 0,
    };
  },
  watch: {
    tabs: {
      handler(tabs) {
        if (tabs?.length) {
          if (this.activeKey) {
            const index = tabs.findIndex((tab) => tab.key === this.activeKey);
            if (index > -1) {
              this.activeIndex = index;
              return;
            }
          }
          this.activeKey = tabs[0].key;
        } else {
          this.activeKey = "";
        }
        this.activeIndex = 0;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    computedTabHeight() {
      switch (typeof this.tabHeight) {
        case "string":
          if (+this.tabHeight == this.tabHeight)
            return `${this.tabHeight / 20}rem`;
          return this.tabHeight;

        case "number":
          return `${this.tabHeight / 20}rem`;

        default:
          return `${50 / 20}rem`;
      }
    },
    computedTabPaddingX() {
      switch (typeof this.tabPaddingX) {
        case "string":
          if (+this.tabPaddingX == this.tabPaddingX)
            return `${this.tabPaddingX / 20}rem`;
          return this.tabPaddingX;

        case "number":
          return `${this.tabPaddingX / 20}rem`;

        default:
          return `${22 / 20}rem`;
      }
    },

    hasSlot() {
      return (
        this.activeKey !== "" &&
        typeof this.$scopedSlots?.[this.activeKey] === "function"
      );
    },
  },
  created() {
    this.throttledOnTabClick = throttle(this.onTabClick, 500);
  },
  methods: {
    onTabClick(tab, index) {
      console.log("onTabClick", index, tab);
      this.activeKey = tab.key;
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.tab-view {
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;

  .tabbar {
    --tab-item-width: calc(
      (100% - var(--tabbar-padding-x) * 2) / var(--tabs-count)
    );

    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: var(--tabbar-height);
    padding: 0 var(--tabbar-padding-x);
    background-color: #fff;

    .tab-item {
      flex: 1;

      width: 0;
      height: 100%;

      line-height: 20/20rem;
      font-weight: 500;
      font-size: 14/20rem;
      letter-spacing: 0;
      color: var(--tabbar-text-color);
      transition: color ease 400ms;

      &.active {
        color: #000000;
      }
    }

    .active-bar-rail {
      position: absolute;
      width: 100%;
      height: 2/20rem;
      left: 0;
      bottom: 0;
      padding: 0 var(--tabbar-padding-x);
      background-color: var(--tabbar-rail-color, transparent);

      .active-bar {
        position: absolute;
        width: var(--tab-item-width);
        height: 2/20rem;
        bottom: 0;
        left: calc(
          var(--tab-item-width) * var(--active-index) + var(--tabbar-padding-x)
        );
        transition: left ease 400ms;

        .active-bar-highlight {
          width: 80/20rem;
          height: 2/20rem;
          margin: auto;
          background-color: #000;
        }
      }
    }
  }

  .active-view {
    flex: 1;
    width: 100%;
    height: 0;
  }
}
</style>
